<template>
  <div class="layout">
    <div class="menu">
      <Menu topIndex="dbWork"></Menu>
    </div>
    <div class="leftSide">
      <LeftSideBar current="dbWork" leftIndex="mediaManage"></LeftSideBar>
    </div>
    <div id="sortContent">
      <div class="left-tree">
        <el-input
          class="subject-search-input"
          placeholder="请输入名称"
          v-model="treeSearchContent"
        ></el-input>
        <el-tree
          ref="tree"
          v-if="opentree"
          :props="props"
          :load="loadNode"
          highlight-current
          icon-class="el-icon-folder"
          :expand-on-click-node="false"
          node-key="id"
          @node-click="listClick"
          :filter-node-method="treeSearch"
          lazy
        >
        </el-tree>
      </div>
      <div class="rightBox">
        <!-- 上方按钮 -->
        <div class="button-box">
          <!-- <el-button type="text" icon="el-icon-document-copy" size="small"
            >批量标引</el-button
          > -->
          <el-button
            type="text"
            icon="el-icon-delete"
            size="small"
            @click="preCheck('toDelete')"
            :disabled="this.listInnerCode == ''"
            >删除</el-button
          >
          <el-button
            type="text"
            icon="el-icon-refresh"
            size="small"
            @click="bkRevert()"
            :disabled="this.deleteId.length == []"
            >恢复</el-button
          >
          <el-button
            type="text"
            icon="el-icon-bottom"
            size="small"
            @click="preCheck('toDown')"
            :disabled="this.listInnerCode == ''"
            >下架</el-button
          >
          <el-button
            type="text"
            icon="el-icon-top"
            size="small"
            @click="preCheck('toUP')"
            :disabled="this.listInnerCode == ''"
            >上架</el-button
          >
          <el-button
            type="text"
            icon="el-icon-c-scale-to-original"
            size="small"
            @click="createIndex()"
            :disabled="this.listInnerCode == ''"
            >创建索引</el-button
          >
          <el-button
            type="text"
            icon="el-icon-download"
            size="small"
            @click="SourceOut()"
            :disabled="this.listInnerCode == ''"
            >资源导出</el-button
          >
          <el-button
            type="text"
            icon="el-icon-tickets"
            size="small"
            @click="listOut()"
            :disabled="this.listInnerCode == ''"
            >导出xml数据包</el-button
          >
          <el-button
            type="text"
            icon="el-icon-document-checked"
            size="small"
            @click="exportDataListByExcel()"
            :disabled="this.listInnerCode == ''"
            >根据Excel导出xml数据包</el-button
          >
          <el-button
            type="text"
            icon="el-icon-document-checked"
            size="small"
            @click="preCheck('addLink')"
            :disabled="this.listInnerCode == ''"
            >维护链接</el-button
          >
        </div>
        <!-- 上方按钮end -->
        <div class="contentBox">
          <div id="searchBox">
            <el-form
              label-width="120px"
              ref="searchFileForm"
              :model="searchFileForm"
            >
              <el-form-item label="资源名称：">
                <el-input
                  v-model="searchFileForm.title"
                  placeholder="请输入资源名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="类型：">
                <el-select
                  placeholder="请选择类型"
                  v-model="searchFileForm.type"
                  clearable
                >
                  <el-option value="1" label="图片"> </el-option>
                  <el-option value="2" label="视频"> </el-option>
                  <el-option value="3" label="音频"> </el-option>
                  <el-option value="4" label="3D"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="资源状态：">
                <el-select v-model="searchFileForm.status" clearable>
                  <el-option value="10" label="下架"> </el-option>
                  <el-option value="20" label="上架"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否有版权：">
                <el-select v-model="searchFileForm.isCopyright" clearable>
                  <el-option value="1" label="否"> </el-option>
                  <el-option value="2" label="是"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否存在原图：">
                <el-select v-model="searchFileForm.isOriginal" clearable>
                  <el-option value="10" label="否"> </el-option>
                  <el-option value="20" label="是"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="入库人：">
                <el-input
                  v-model="searchFileForm.addUser"
                  placeholder="请输入入库人"
                ></el-input>
              </el-form-item>
              <el-form-item label="入库时间：">
                <el-date-picker
                  v-model="searchFileForm.addTime"
                  type="date"
                  value-format="yy-mm-dd"
                  placeholder="选择入库时间"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="合同类型：">
                <el-input
                  v-model="searchFileForm.permitType"
                  placeholder="请输入合同类型"
                ></el-input>
              </el-form-item>
              <el-form-item label="许可范围：">
                <el-input
                  v-model="searchFileForm.permitScope"
                  placeholder="请输入许可范围"
                ></el-input>
              </el-form-item>
              <el-form-item label="许可期限：">
                <el-input
                  v-model="searchFileForm.contract"
                  placeholder="请输入许可期限"
                ></el-input>
              </el-form-item>
              <el-form-item label-width="0px">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-search"
                  @click="
                    currentPage = 1;
                    onSearch();
                  "
                  >查询</el-button
                >
              </el-form-item>
            </el-form>
          </div>
          <div>
            <div class="tip-text" v-if="this.listInnerCode == ''">
              请选择资源库
            </div>
            <!-- 主列表 -->
            <div v-if="this.listInnerCode != ''" class="mediaManageBox">
              <el-table
                :data="bkTableData"
                v-loading="tableLoading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-customClass="loadingStyles"
                style="width: 100%"
                class="maintable"
                border
                :header-cell-style="{ background: '#f8f8f8' }"
                @selection-change="handleTableSelectionChange"
              >
                <el-table-column
                  type="selection"
                  min-width="55"
                  align="center"
                ></el-table-column>
                <el-table-column type="index" min-width="50" align="center">
                </el-table-column>
                <el-table-column
                  prop="logoPath"
                  min-width="50"
                  align="center"
                  label="封面图"
                >
                  <template slot-scope="scope">
                    <img
                      :src="scope.row.logoPath"
                      style="width: 100%; max-height: 90px"
                    />
                  </template>
                </el-table-column>
                <el-table-column
                  prop="title"
                  show-overflow-tooltip
                  min-width="80"
                  label="资源标题"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="subjectInfo.name"
                  min-width="80"
                  label="分支"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="status"
                  show-overflow-tooltip
                  label="状态"
                  min-width="70px"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span effect="dark" v-if="scope.row.status == 20"
                      >已上架</span
                    >
                    <span effect="dark" v-if="scope.row.status == 10"
                      >未上架</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="type"
                  show-overflow-tooltip
                  label="类型"
                  min-width="70px"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span effect="dark" v-if="scope.row.type == 1">图片</span>
                    <span effect="dark" v-if="scope.row.type == 2">视频</span>
                    <span effect="dark" v-if="scope.row.type == 3">音频</span>
                    <span effect="dark" v-if="scope.row.type == 4">3D</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="isOriginal"
                  show-overflow-tooltip
                  label="是否存在原图"
                  min-width="70px"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span effect="dark" v-if="scope.row.isOriginal == 10"
                      >否</span
                    >
                    <span effect="dark" v-if="scope.row.isOriginal == 20"
                      >是</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="isCopyright"
                  show-overflow-tooltip
                  label="是否有版权"
                  min-width="70px"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span effect="dark" v-if="scope.row.isCopyright == 1"
                      >否</span
                    >
                    <span effect="dark" v-if="scope.row.isCopyright == 2"
                      >是</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="isRemove"
                  show-overflow-tooltip
                  label="是否已被删除"
                  min-width="70px"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span
                      effect="dark"
                      v-if="
                        scope.row.isRemove == 10 || scope.row.isRemove == null
                      "
                      >否</span
                    >
                    <span effect="dark" v-if="scope.row.isRemove == 20"
                      >是</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="fileSize"
                  show-overflow-tooltip
                  label="文件大小"
                  min-width="70px"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="addUser"
                  show-overflow-tooltip
                  label="入库人"
                  min-width="70px"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="addTime"
                  show-overflow-tooltip
                  label="入库时间"
                  min-width="70px"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  label="操作"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span
                      class="right-add-button"
                      style="display: block"
                      @click="editFile(scope.row)"
                      >【编辑】</span
                    >
                    <span
                      class="right-add-button"
                      style="display: block"
                      @click="preview(scope.row)"
                      >【预览】</span
                    >
                    <span
                      class="right-add-button"
                      style="display: block"
                      @click="publishPreview(scope.row)"
                      >【发布预览】</span
                    >
                  </template>
                </el-table-column>
              </el-table>
              <!-- 主列表分页 -->
              <div class="pagination-box">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="totalSize"
                >
                </el-pagination>
              </div>
            </div>
          </div>

          <!-- 资源出库弹窗 -->
          <el-dialog title="资源出库" :visible.sync="outDialog" width="600px">
            <el-form>
              <el-form-item label="导出字段：">
                <el-select
                  v-model="exportForm.exportTitles"
                  clearable
                  multiple
                  collapse-tags
                  placeholder="请选择导出列表字段"
                >
                  <el-option
                    v-for="item in exportTitlesList"
                    :key="item.value"
                    :value="item.value"
                    :label="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="toExport()">确 定</el-button>
              <el-button @click="outDialog = false">取 消</el-button>
            </span>
          </el-dialog>
          <!-- 导出xml数据包弹窗 -->
          <el-dialog
            title="导出xml数据包"
            :visible.sync="listOutDialog"
            width="800px"
          >
            <el-form
              ref="exportDataListForm"
              :model="exportDataListForm"
              :rules="exportDataListRules"
              label-width="140px"
            >
              <el-form-item label="是否导出资源:" prop="isExportResource">
                <el-select v-model="exportDataListForm.isExportResource">
                  <el-option value="10" label="否"></el-option>
                  <el-option value="20" label="是"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                v-if="exportDataListForm.isExportResource == '20'"
                label="是否导出水印:"
                prop="isExportWatermark"
              >
                <el-select v-model="exportDataListForm.isExportWatermark">
                  <el-option value="10" label="否"></el-option>
                  <el-option value="20" label="是"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                label="是否导出原始资源:"
                prop="isExportSourceResource"
                v-if="exportDataListForm.isExportResource == '20'"
              >
                <el-select v-model="exportDataListForm.isExportSourceResource">
                  <el-option value="10" label="否"></el-option>
                  <el-option value="20" label="是"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="导出用户:">
                <el-input
                  type="text"
                  v-model="exportDataListForm.expUser"
                  placeholder="请填写导出用户"
                ></el-input>
              </el-form-item>
              <el-form-item label="用途:">
                <el-input
                  type="text"
                  v-model="exportDataListForm.expYt"
                  placeholder="请填写用途"
                ></el-input>
              </el-form-item>
              <el-form-item label="使用人员:">
                <el-input
                  type="text"
                  v-model="exportDataListForm.toUser"
                  placeholder="请填写使用人员"
                ></el-input>
              </el-form-item>
              <el-form-item label="使用部门:">
                <el-input
                  type="text"
                  v-model="exportDataListForm.toDept"
                  placeholder="请填写使用部门"
                ></el-input>
              </el-form-item>
              <el-form-item label="审核意见:">
                <el-input
                  type="text"
                  v-model="exportDataListForm.expAudit"
                  placeholder="请填写审核意见"
                ></el-input>
              </el-form-item>
              <el-form-item label="导出时间:">
                <el-date-picker
                  v-model="exportDataListForm.expTime"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="exportDataList()"
                >确 定</el-button
              >
              <el-button @click="listOutDialog = false">取 消</el-button>
            </span>
          </el-dialog>
          <!-- 根据Excel导出xml数据包弹窗 -->
          <el-dialog
            title="根据Excel导出xml数据包"
            :visible.sync="exportDataListByExcelDialog"
            width="800px"
          >
            <el-form
              ref="exportDataListForm"
              :model="exportDataListForm"
              :rules="exportDataListRules"
              label-width="140px"
            >
              <el-form-item label="是否导出资源:" prop="isExportResource">
                <el-select v-model="exportDataListForm.isExportResource">
                  <el-option value="10" label="否"></el-option>
                  <el-option value="20" label="是"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                v-if="exportDataListForm.isExportResource == '20'"
                label="是否导出水印:"
                prop="isExportWatermark"
              >
                <el-select v-model="exportDataListForm.isExportWatermark">
                  <el-option value="10" label="否"></el-option>
                  <el-option value="20" label="是"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                label="是否导出原始资源:"
                prop="isExportSourceResource"
                v-if="exportDataListForm.isExportResource == '20'"
              >
                <el-select v-model="exportDataListForm.isExportSourceResource">
                  <el-option value="10" label="否"></el-option>
                  <el-option value="20" label="是"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="导出用户:">
                <el-input
                  type="text"
                  v-model="exportDataListForm.expUser"
                  placeholder="请填写导出用户"
                ></el-input>
              </el-form-item>
              <el-form-item label="用途:">
                <el-input
                  type="text"
                  v-model="exportDataListForm.expYt"
                  placeholder="请填写用途"
                ></el-input>
              </el-form-item>
              <el-form-item label="使用人员:">
                <el-input
                  type="text"
                  v-model="exportDataListForm.toUser"
                  placeholder="请填写使用人员"
                ></el-input>
              </el-form-item>
              <el-form-item label="使用部门:">
                <el-input
                  type="text"
                  v-model="exportDataListForm.toDept"
                  placeholder="请填写使用部门"
                ></el-input>
              </el-form-item>
              <el-form-item label="审核意见:">
                <el-input
                  type="text"
                  v-model="exportDataListForm.expAudit"
                  placeholder="请填写审核意见"
                ></el-input>
              </el-form-item>
              <el-form-item label="导出时间:">
                <el-date-picker
                  v-model="exportDataListForm.expTime"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-form>
            <el-upload
              ref="upload"
              action="zyk/a/exportDataListByExcel"
              :headers="headers"
              :file-list="fileList"
              name="upfile"
              :before-upload="excelBeforeUpload"
              :on-success="excelUploadSuccess"
              :on-error="excelUploaderror"
              :auto-upload="false"
              accept=".xlsx"
              :data="exportDataListForm"
              :limit="1"
            >
              <div slot="tip" class="el-upload__tip">
                文件格式：资源库条目ID，原始ID（两列写一列即可）
              </div>
              <el-button slot="trigger" size="small" type="primary"
                >选择文件</el-button
              >
              <!-- <el-button size="small" type="success" @click="submitUpload"
                >上传并导入</el-button
              > -->
            </el-upload>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="excelsubmitUpload"
                >确 定</el-button
              >
              <el-button @click="exportDataListByExcelDialog = false"
                >取 消</el-button
              >
            </span>
          </el-dialog>
          <!-- 删除确认弹窗 -->
          <el-dialog
            title="删除分类"
            :visible.sync="deletePreDialog"
            width="600px"
          >
            <div>确定删除该分类</div>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="bkDelete">确 定</el-button>
              <el-button @click="deletePreDialog = false">取 消</el-button>
            </span>
          </el-dialog>
          <!-- 维护链接弹窗 -->
          <el-dialog
            title="链接维护"
            :visible.sync="addLinkDialog"
            width="600px"
          >
            <el-form ref="addLinkData" label-width="100px" :model="addLinkData">
              <el-form-item label="链接描述：">
                <el-input
                  v-model="addLinkData.title"
                  placeholder="请输入链接描述"
                ></el-input>
              </el-form-item>
              <el-form-item label="链接：">
                <el-input
                  v-model="addLinkData.link"
                  placeholder="请输入链接"
                ></el-input>
              </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="addLink">确 定</el-button>
              <el-button @click="addLinkDialog = false">取 消</el-button>
            </span>
          </el-dialog>
          <!-- 查看日志弹窗 -->
          <el-dialog
            title="资源对比"
            :visible.sync="logViewDialog"
            width="900px"
          >
            <p style="margin-bottom: 20px">
              查看词条日志：<span>菲律宾魔杖</span>
            </p>
            <el-table
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
              style="width: 100%"
              class="maintable"
              border
              :header-cell-style="{ background: '#f8f8f8' }"
            >
              <el-table-column type="index" min-width="50" align="center">
              </el-table-column>
              <el-table-column
                prop="name"
                show-overflow-tooltip
                min-width="80"
                label="名称"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="address"
                min-width="80"
                label="操作类型"
                align="center"
              >
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                label="操作明细"
                min-width="70px"
                align="center"
              >
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                label="用户名"
                min-width="70px"
                align="center"
              >
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                label="时间"
                align="center"
              >
              </el-table-column>
            </el-table>
            <span
              slot="footer"
              class="dialog-footer"
              style="text-align: center"
            >
              <el-button @click="logViewDialog = false">取 消</el-button>
            </span>
          </el-dialog>
          <!-- 查看版本弹窗 -->
          <el-dialog
            title="历史版本"
            :visible.sync="versionDialog"
            width="900px"
          >
            <el-table
              :data="versionListData"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
              style="width: 100%"
              class="maintable"
              border
              :header-cell-style="{ background: '#f8f8f8' }"
            >
              <el-table-column type="index" min-width="50" align="center">
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                min-width="80"
                label="条目名称"
                align="center"
                >{{ fileName }}</el-table-column
              >
              <el-table-column
                prop="addUser"
                min-width="80"
                label="提交人"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="addTime"
                show-overflow-tooltip
                label="操作时间"
                min-width="70px"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="version"
                show-overflow-tooltip
                label="版本号"
                width="80px"
                align="center"
              >
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                label="操作"
                align="center"
              >
                <template slot-scope="scope">
                  <span
                    class="right-add-button"
                    style="display: block"
                    @click="preview(scope.row)"
                    >【预览】</span
                  >
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination-box">
              <el-pagination
                @size-change="handleSizeChange1"
                @current-change="handleCurrentChange1"
                :current-page="currentPage1"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize1"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalSize1"
              >
              </el-pagination>
            </div>
            <span
              slot="footer"
              class="dialog-footer"
              style="text-align: center"
            >
              <el-button @click="versionDialog = false">取 消</el-button>
            </span>
          </el-dialog>
          <!-- 源文件编辑弹窗 -->
          <el-dialog
            title="源文件编辑"
            :visible.sync="editDialog"
            width="1000px"
          >
            <el-form
              ref="editFileForm"
              label-width="100px"
              :rules="editFileRules"
              :model="editFileForm"
            >
              <el-form-item label="资源标题" style="width: 50%" prop="title">
                <el-input
                  v-model="editFileForm.title"
                  placeholder="请输入资源标题"
                ></el-input>
              </el-form-item>
              <el-form-item label="资源名称" style="width: 50%" prop="oldName">
                <el-input
                  v-model="editFileForm.oldName"
                  placeholder="请输入资源名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="资源描述" style="width: 100%">
                <el-input
                  type="textarea"
                  v-model="editFileForm.description"
                  placeholder="请输入资源描述"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="是否存在原图"
                prop="isOriginal"
                label-width="110px"
              >
                <el-select
                  placeholder="是否存在原图"
                  v-model="editFileForm.isOriginal"
                  style="width: 100%"
                  clearable
                >
                  <el-option value="10" label="无"> </el-option>
                  <el-option value="20" label="有"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="分支" style="width: 50%" prop="subjectId">
                <!-- 分支树开始 -->
                <el-select
                  placeholder="请选择分支"
                  v-model="selectedValue"
                  style="width: 100%"
                  clearable
                >
                  <el-option :value="dataList"
                    ><el-tree
                      ref="tree"
                      :props="props"
                      :load="loadNode"
                      check-on-click-node
                      highlight-current
                      :expand-on-click-node="false"
                      @check-change="handleCheckChange"
                      node-key="id"
                      lazy
                    >
                    </el-tree>
                  </el-option>
                </el-select>
                <!-- 分支树结束 -->
              </el-form-item>
              <el-form-item label="类型" style="width: 50%" prop="type">
                <el-select
                  placeholder="请选择类型"
                  v-model="editFileForm.type"
                  style="width: 100%"
                  @change="addTypeChange"
                  clearable
                >
                  <el-option value="1" label="图片"> </el-option>
                  <el-option value="2" label="视频"> </el-option>
                  <el-option value="3" label="音频"> </el-option>
                  <el-option value="4" label="3D"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="缩略图" prop="logoPath">
                <div class="uploadBox">
                  <el-upload
                    class="avatar-uploader"
                    ref="logoUpload"
                    action="/zyk/resource/upload"
                    :headers="headers"
                    :show-file-list="false"
                    name="upfile"
                    :data="upLodeData"
                    :before-upload="beforeAvatarUpload"
                    :on-success="handleAvatarSuccess"
                  >
                    <img v-if="logoImgUrl" :src="logoImgUrl" class="avatar" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </div>
              </el-form-item>
              <el-form-item label="资源上传" prop="httpPath">
                <div class="uploadBox">
                  <el-upload
                    ref="zyupload"
                    action="/zyk/resource/upload"
                    :headers="headers"
                    :file-list="zyfileList"
                    name="upfile"
                    :before-upload="beforeUpload"
                    :on-success="zySuccess"
                    :auto-upload="false"
                    :accept="acceptType"
                    :data="upLodeData"
                    :limit="1"
                  >
                    <el-button slot="trigger" size="small" type="primary"
                      >选择文件</el-button
                    >
                    <el-button
                      size="small"
                      type="success"
                      @click="zySubmitUpload"
                      >开始上传</el-button
                    >
                  </el-upload>
                </div>
              </el-form-item>
              <el-form-item
                label="原图上传"
                v-if="this.editFileForm.isOriginal == 20"
              >
                <div class="uploadBox">
                  <el-upload
                    ref="ytupload"
                    action="/zyk/resource/upload"
                    :headers="headers"
                    :file-list="ytfileList"
                    name="upfile"
                    :before-upload="beforeUpload"
                    :on-success="yuSuccess"
                    :auto-upload="false"
                    :data="upLodeData"
                    :limit="1"
                  >
                    <el-button slot="trigger" size="small" type="primary"
                      >选择文件</el-button
                    >
                    <el-button
                      size="small"
                      type="success"
                      @click="ytSubmitUpload"
                      >开始上传</el-button
                    >
                  </el-upload>
                </div>
              </el-form-item>
              <el-form-item label="是否外部资源" style="width: 50%">
                <el-select
                  placeholder="是否外部资源"
                  v-model="editFileForm.isOuter"
                  style="width: 100%"
                  clearable
                >
                  <el-option value="10" label="内部资源"> </el-option>
                  <el-option value="20" label="外部资源"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="许可期限" style="width: 50%">
                <el-input
                  v-model="editFileForm.permitTime"
                  placeholder="请输入许可期限"
                ></el-input>
              </el-form-item>
              <el-form-item label="关键字" style="width: 50%">
                <el-input
                  v-model="editFileForm.word"
                  placeholder="请输入关键字"
                ></el-input>
              </el-form-item>
              <el-form-item label="来源" style="width: 50%">
                <el-input
                  v-model="editFileForm.origin"
                  placeholder="请输入来源"
                ></el-input>
              </el-form-item>
              <el-form-item label="来源ID" style="width: 50%">
                <el-input
                  v-model="editFileForm.originId"
                  placeholder="请输入来源ID"
                ></el-input> </el-form-item
              ><el-form-item label="主讲人" style="width: 50%">
                <el-input
                  v-model="editFileForm.zjr"
                  placeholder="请输入主讲人"
                ></el-input> </el-form-item
              ><el-form-item label="主讲人单位" style="width: 50%">
                <el-input
                  v-model="editFileForm.zjrdw"
                  placeholder="请输入主讲人单位"
                ></el-input> </el-form-item
              ><el-form-item label="主讲人简介" style="width: 50%">
                <el-input
                  v-model="editFileForm.zjrjj"
                  placeholder="请输入主讲人简介"
                ></el-input> </el-form-item
              ><el-form-item label="文字稿">
                <el-input
                  type="textarea"
                  v-model="editFileForm.wzg"
                  placeholder="请输入文字稿"
                  style="width: 100%"
                ></el-input> </el-form-item
              ><el-form-item label="目录">
                <el-input
                  type="textarea"
                  v-model="editFileForm.menu"
                  placeholder="请输入目录"
                  style="width: 100%"
                ></el-input> </el-form-item
              ><el-form-item label="著作权人" style="width: 50%">
                <el-input
                  v-model="editFileForm.copyright"
                  placeholder="请输入著作权人"
                ></el-input> </el-form-item
              ><el-form-item label="合同期限" style="width: 50%">
                <el-input
                  v-model="editFileForm.contract"
                  placeholder="请输入合同期限"
                ></el-input> </el-form-item
              ><el-form-item label="许可类型" style="width: 50%">
                <el-input
                  v-model="editFileForm.permitType"
                  placeholder="请输入许可类型"
                ></el-input> </el-form-item
              ><el-form-item label="许可范围" style="width: 50%">
                <el-input
                  v-model="editFileForm.permitScope"
                  placeholder="请输入许可范围"
                ></el-input>
              </el-form-item>
              <el-form-item label="资源类别" style="width: 50%">
                <el-input
                  v-model="editFileForm.resourceType"
                  placeholder="请输入资源类别"
                ></el-input>
              </el-form-item>
              <el-form-item label="来源方式" style="width: 50%">
                <el-input
                  v-model="editFileForm.dealtype"
                  placeholder="请输入来源方式"
                ></el-input>
              </el-form-item>

              <!-- 图片专属input -->
              <div class="picInput" v-if="this.editFileForm.type == 1">
                <el-form-item label="图片大小" style="width: 50%">
                  <el-input
                    v-model="editFileForm.imageRatio"
                    placeholder="请输入图片大小"
                  ></el-input>
                </el-form-item>
                <el-form-item label="图注" style="width: 50%">
                  <el-input
                    v-model="editFileForm.imageNote"
                    placeholder="请输入图注"
                  ></el-input>
                </el-form-item>
              </div>
              <!-- 音频专属input -->
              <div class="audioInput" v-if="this.editFileForm.type == 3">
                <el-form-item label="音频语种" style="width: 50%">
                  <el-input
                    v-model="editFileForm.audioLanguage"
                    placeholder="请输入音频语种"
                  ></el-input>
                </el-form-item>
                <el-form-item label="作词" style="width: 50%">
                  <el-input
                    v-model="editFileForm.audioWordAuthor"
                    placeholder="请输入作词"
                  ></el-input>
                </el-form-item>
                <el-form-item label="作曲" style="width: 50%">
                  <el-input
                    v-model="editFileForm.audioComposeAuthor"
                    placeholder="请输入作曲"
                  ></el-input>
                </el-form-item>
                <el-form-item label="演唱者" style="width: 50%">
                  <el-input
                    v-model="editFileForm.audioSinger"
                    placeholder="请输入演唱者"
                  ></el-input>
                </el-form-item>
                <el-form-item label="演奏" style="width: 50%">
                  <el-input
                    v-model="editFileForm.audioExecutant"
                    placeholder="请输入演奏"
                  ></el-input>
                </el-form-item>
                <el-form-item label="专辑" style="width: 50%">
                  <el-input
                    v-model="editFileForm.audioAlbum"
                    placeholder="请输入专辑"
                  ></el-input>
                </el-form-item>
                <el-form-item label="比特率" style="width: 50%">
                  <el-input
                    v-model="editFileForm.audioBitRate"
                    placeholder="请输入比特率"
                  ></el-input>
                </el-form-item>
                <el-form-item label="采样率" style="width: 50%">
                  <el-input
                    v-model="editFileForm.audioSamplingRate"
                    placeholder="请输入采样率"
                  ></el-input>
                </el-form-item>
                <el-form-item label="时长" style="width: 50%">
                  <el-input
                    v-model="editFileForm.audioTimeLong"
                    placeholder="请输入时长"
                  ></el-input>
                </el-form-item>
              </div>
              <!-- 视频专属input -->
              <div class="videoInput" v-if="this.editFileForm.type == 2">
                <el-form-item label="系列题名" style="width: 50%">
                  <el-input
                    v-model="editFileForm.videoSeriesTitle"
                    placeholder="请输入系列题名"
                  ></el-input>
                </el-form-item>
                <el-form-item label="分集数" style="width: 50%">
                  <el-input
                    v-model="editFileForm.videoDiversityTotal"
                    placeholder="请输入分集数"
                  ></el-input>
                </el-form-item>
                <el-form-item label="色彩" style="width: 50%">
                  <el-input
                    v-model="editFileForm.videoColor"
                    placeholder="请输入色彩"
                  ></el-input>
                </el-form-item>
                <el-form-item label="时代" style="width: 50%">
                  <el-input
                    v-model="editFileForm.videoPeriod"
                    placeholder="请输入时代"
                  ></el-input>
                </el-form-item>
                <el-form-item label="视频声道语种" style="width: 50%">
                  <el-input
                    v-model="editFileForm.videoVoice"
                    placeholder="请输入视频声道语种"
                  ></el-input>
                </el-form-item>
                <el-form-item label="字幕">
                  <el-input
                    type="textarea"
                    v-model="editFileForm.videoCaption"
                    placeholder="请输入字幕"
                  ></el-input>
                </el-form-item>
              </div>
            </el-form>
            <span
              slot="footer"
              class="dialog-footer"
              style="text-align: center"
            >
              <el-button type="primary" @click="bkEdit(editFileForm)"
                >确 定
              </el-button>
              <el-button @click="editDialog = false">取 消</el-button>
            </span>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "../../menu/menu.vue";
import LeftSideBar from "../../menu/leftSideBar.vue";
import $ from "jquery";
import cookies from "vue-cookies";
export default {
  data: function () {
    return {
      exportTitlesList: [],
      fileList: [], //上传文件列表
      listData: [],
      tableLoading: false,
      getAuthority: {},
      versionListData: [],
      currentPage: 1,
      pageSize: 10,
      totalSize: 50,
      currentPage1: 1,
      pageSize1: 10,
      totalSize1: 50,
      dataText: "",

      optionData: [],
      bkTableData: [],
      treeData: [],
      treeNode_had: [],
      treeResolve_had: [],
      multipleSelectionTable: [],
      sourceList: [],
      searchFileForm: {},
      sortContentForm: {},
      treeSearchContent: "",
      listInnerCode: "",
      opentree: true,

      fileName: "",
      deleteId: [],
      editFileForm: {},
      props: {
        label: "name",
        children: "children",
        isLeaf: "leaf",
      },

      // 资源编辑
      logInterval: null,
      selectedValue: null,
      logoImgUrl: "",
      fileType: "", // 文件类型
      zyfileList: [],
      ytfileList: [], //上传文件列表
      dataList: [],
      acceptType: "",
      headers: {
        AuthorizationToken: cookies.get("token"),
      },
      upLodeData: {
        type: "",
      },

      exportForm: {},
      exportDataListForm: {},

      addLinkData: {},

      // 弹窗组
      outDialog: false,
      deletePreDialog: false,
      listOutDialog: false,
      exportDataListByExcelDialog: false,
      specialOutDialog: false,
      compareDialog: false,
      logViewDialog: false,
      versionDialog: false,
      editDialog: false,
      addLinkDialog: false,
      // 规则
      editFileRules: {
        title: [{ required: true, message: "请输入名称", trigger: "blur" }],
        subjectId: [{ required: true, trigger: "blur" }],
        oldName: [{ required: true, message: "请输入名称", trigger: "blur" }],
        isOriginal: [
          { required: true, message: "请选择是否有原始资源", trigger: "blur" },
        ],
        type: [{ required: true, message: "请选择类型", trigger: "blur" }],
        httpPath: [{ required: true, trigger: "blur" }],
      },
      exportDataListRules: {
        isExportWatermark: [
          { required: true, message: "请选择请选择", trigger: "blur" },
        ],
        isExportResource: [
          { required: true, message: "请选择是否导出资源", trigger: "blur" },
        ],
        isExportSourceResource: [
          {
            required: true,
            message: "请选择是否导出原始资源",
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: {
    Menu,
    LeftSideBar,
  },
  mounted() {
    // 统一验证token
    var currentToken = cookies.get("token");
    $.ajaxSetup({
      headers: {
        AuthorizationToken: currentToken,
      },
      complete: function (xhr) {
        if (xhr.responseJSON.code == 401) {
          window.location.href = "/";
        }
      },
    });
    this.searchParam();
    this.getSourceList();
  },
  watch: {
    treeSearchContent(val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    // 搜索
    onSearch() {
      this.searchParam();
    },
    // 加载数据
    searchParam() {
      let that = this;
      // let params = {};
      let params = Object.assign({}, this.searchFileForm);
      params.innerCode = this.listInnerCode;
      params.size = this.pageSize;
      params.page = this.currentPage;
      that.tableLoading = true;
      $.ajax({
        type: "GET",
        dataType: "json",
        url: "/zyk/c/resource/resourceInfo/list",
        data: params,
        // contentType: "application/json;charset=utf-8",
        success: function (response) {
          if (response.code == 200) {
            that.optionData = response.obj.list;
            if (response.obj.list && response.obj.list.length == 0) {
              that.dataText = "暂无数据";
            }
            that.tableLoading = false;
            that.totalSize = response.obj.total;
            that.bkTableData = response.obj.list;
            that.currentPage = response.obj.pageNum;
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },
    // 树形结构加载
    loadNode(node, resolve) {
      let that = this;
      this.getAuthority = node;
      var currentToken = cookies.get("token");
      $.ajax({
        url: "/zyk/subject/resourceSubject?size=1000&page=1",
        type: "GET",
        data: { flag: 10 },
        headers: {
          AuthorizationToken: currentToken,
        },
        //contentType: 'application/json;charset=utf-8',
        dataType: "json",
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          if (node.level == 0) {
            this.treeNode_had = node;
            that.dataList = data.obj.list;
            return resolve(that.dataList);
          } else {
            $.ajax({
              url: "/zyk/c/subject/subjectInfo/list?size=1000&page=1",
              type: "GET",
              //contentType: 'application/json;charset=utf-8',
              data: { id: node.data.id },
              dataType: "json",
              error: function (xhr) {
                if (xhr.status == 401) {
                  window.location.reload();
                }
              },
              success: function (data) {
                return resolve(data.obj.list);
              },
            });
          }
        },
      });
    },
    // 点击树
    listClick(node) {
      let that = this;
      that.getAuthority = node;
      if (node.id == -1) {
        that.sortContentForm = {
          id: "-1",
          name: "百科数据资源库",
        };
      } else {
        that.listInnerCode = node.innerCode;
        that.searchParam();
      }
    },
    // 删除、上下架前确认
    preCheck(current) {
      let that = this;
      let ids = this.multipleSelectionTable.map((item) => {
        return item.id;
      });
      let flagArr = [];
      let flag = true;
      let statusArr = this.multipleSelectionTable.map((item) => {
        return item.status;
      });
      if (this.multipleSelectionTable.length == 0) {
        this.$message({
          message: "请选中具体的资源",
          duration: 0,
          showClose: true,
          type: "error",
          offset: 100,
        });
      } else if (current == "toDown") {
        $.each(statusArr, function (index, element) {
          if (element === 20) {
            flagArr.push(true);
          } else {
            flagArr.push(false);
          }
        });
        flag = flagArr.every(function (value) {
          return value;
        });
        if (!flag) {
          that.$message({
            message: "资源下架状态，不可重复下架",
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
        } else {
          $.ajax({
            type: "POST",
            dataType: "json",
            data: {
              ids: ids.toString(),
              status: 10,
            },
            url: "/zyk/resource/updown",
            success: function (response) {
              if (response.code == 200) {
                that.searchParam();
                console.log("资源已下架");
              } else {
                that.$message({
                  message: response.msg,
                  duration: 0,
                  showClose: true,
                  type: "error",
                  offset: 100,
                });
              }
            },
            error: function (data) {
              console.log(data);
            },
          });
        }
      } else if (current == "toUP") {
        $.each(statusArr, function (index, element) {
          if (element === 10) {
            flagArr.push(true);
          } else {
            flagArr.push(false);
          }
        });
        flag = flagArr.every(function (value) {
          return value;
        });
        if (!flag) {
          that.$message({
            message: "资源上架状态，不可重复上架",
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
        } else {
          $.ajax({
            type: "POST",
            dataType: "json",
            data: {
              ids: ids.toString(),
              status: 20,
            },
            url: "/zyk/resource/updown",
            success: function (response) {
              if (response.code == 200) {
                that.searchParam();
                console.log("资源已上架");
              } else {
                that.$message({
                  message: response.msg,
                  duration: 0,
                  showClose: true,
                  type: "error",
                  offset: 100,
                });
              }
            },
            error: function (data) {
              console.log(data);
            },
          });
        }
      } else if (current == "toDelete") {
        $.each(statusArr, function (index, element) {
          if (element === 10) {
            flagArr.push(true);
          } else {
            flagArr.push(false);
          }
        });
        flag = flagArr.every(function (value) {
          return value;
        });
        if (!flag) {
          that.$message({
            message: "非停用状态资源不可删除，请停用后再删除",
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
        } else {
          this.deletePreDialog = true;
        }
      } else if (current == "addLink") {
        if (this.multipleSelectionTable.length == 1) {
          this.addLinkData.linkContent =
            this.multipleSelectionTable[0].resourceInfoExtend.linkContent;

          this.addLinkData.link =
            this.multipleSelectionTable[0].resourceInfoExtend.link;
        }
        this.addLinkDialog = true;
      }
    },
    // 编辑确认
    bkEdit(formName) {
      let that = this;
      $.ajax({
        url: "/zyk/c/resource/resourceInfo/add",
        type: "POST",
        dataType: "json",
        data: formName,
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          if (data.code == 200) {
            that.$message({
              message: "成功",
              duration: 2000,
              showClose: true,
              type: "success",
              offset: 100,
            });
            that.searchParam();
            that.editDialog = false;
          } else {
            that.$message({
              message: data.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
      });
    },
    // 删除确认
    bkDelete() {
      let that = this;
      that.deleteId = this.multipleSelectionTable.map((item) => {
        return item.id;
      });
      $.ajax({
        type: "POST",
        dataType: "json",
        data: {
          ids: this.deleteId.toString(),
        },
        url: "/zyk/c/resource/resourceInfo/remove",
        success: function (response) {
          if (response.code == 200) {
            that.searchParam();
            that.$message({
              message: "删除成功",
              duration: 0,
              showClose: true,
              type: "success",
              offset: 100,
            });
            that.deletePreDialog = false;
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },
    // 链接维护确认
    addLink() {
      let that = this;
      var addLinkId = this.multipleSelectionTable.map((item) => {
        return item.id;
      });
      $.ajax({
        type: "POST",
        dataType: "json",
        data: {
          ids: addLinkId.toString(),
          link: that.addLinkData.link,
          linkContent: that.addLinkData.linkContent,
        },
        url: "/zyk/resource/updateLink",
        success: function (response) {
          if (response.code == 200) {
            that.searchParam();
            that.$message({
              message: "添加成功",
              duration: 0,
              showClose: true,
              type: "success",
              offset: 100,
            });
            that.addLinkDialog = false;
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },
    // 恢复确认
    bkRevert() {
      let that = this;
      $.ajax({
        type: "POST",
        dataType: "json",
        data: {
          ids: this.deleteId.toString(),
        },
        url: "/zyk/c/resource/resourceInfo/revert",
        success: function (response) {
          if (response.code == 200) {
            that.searchParam();
            that.$message({
              message: "恢复成功",
              duration: 0,
              showClose: true,
              type: "success",
              offset: 100,
            });
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },

    // 上传文件之前的钩子，对文件大小进行校验
    beforeUpload(file) {
      let that = this;
      const isLt2M = file.size / 1024 / 1024 / 1024 < 4;
      if (!isLt2M) {
        this.$message.error("资源超过上传上限4G，如仍需上传，请联系管理员。");
        return isLt2M;
      } else {
        that.upLodeData = {
          type: this.editFileForm.type,
        };
      }
    },
    beforeBatchUploadData(file) {
      let that = this;
      const isLt2M = file.size / 1024 / 1024 / 1024 < 4;
      if (!isLt2M) {
        this.$message.error("资源超过上传上限4G，如仍需上传，请联系管理员。");
        return isLt2M;
      } else {
        that.batchUploadData = {
          type: this.BUType,
          subjectId: this.BUSubjectId,
        };
      }
    },
    // 上传成功的钩子
    zySuccess(response) {
      let that = this;
      that.editFileForm.httpPath = response.obj;
    },
    // 源文件上传成功回调，设置资源路径
    yuSuccess(response) {
      let that = this;
      that.editFileForm.resourcePath = response.obj;
    },

    // 文件上传
    zySubmitUpload() {
      this.$refs.zyupload.data.type = this.editFileForm.type;
      this.$refs.zyupload.submit();
    },
    ytSubmitUpload() {
      this.$refs.ytupload.data.type = this.editFileForm.type;
      this.$refs.ytupload.submit();
    },
    sourceCompare() {
      this.compareDialog = true;
    },
    logView() {
      this.logViewDialog = true;
    },
    versionView(row) {
      this.versionDialog = true;
      let that = this;
      let params = {};
      params.wordId = row.id;
      params.size = this.pageSize;
      params.page = this.currentPage;
      $.ajax({
        type: "GET",
        dataType: "json",
        url: "/zyk/c/subject/wordExtendInfo/list",
        data: params,
        contentType: "application/json;charset=utf-8",
        success: function (response) {
          if (response.code == 200) {
            that.optionData = response.obj.list;
            if (response.obj && response.obj.length == 0) {
              that.dataText = "暂无数据";
            }
            that.totalSize1 = response.obj.total;
            that.versionListData = response.obj.list;
            that.fileName = row.name;
            that.currentPage1 = response.obj.pageNum;
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },
    // 编辑条目
    editFile(row) {
      let that = this;
      that.selectedValue = row.subjectInfo.name;
      that.logoImgUrl = row.logoPath;
      that.zyfileList = [
        {
          name: row.oldName,
          url: row.httpPath,
        },
      ];
      if (row.isOriginal == 20) {
        that.ytfileList = [
          {
            name: row.title,
            url: row.resourcePath,
          },
        ];
      }
      if (row.type == 1) {
        that.editFileForm.imageNote = row.resourceInfoExtend.imageNote;
        that.editFileForm.imageRatio = row.resourceInfoExtend.imageRatio;
      } else if (row.type == 3) {
        that.editFileForm.audioLanguage = row.resourceInfoExtend.audioLanguage;
        that.editFileForm.audioWordAuthor =
          row.resourceInfoExtend.audioWordAuthor;
        that.editFileForm.audioComposeAuthor =
          row.resourceInfoExtend.audioComposeAuthor;
        that.editFileForm.audioSinger = row.resourceInfoExtend.audioSinger;
        that.editFileForm.audioExecutant =
          row.resourceInfoExtend.audioExecutant;
        that.editFileForm.audioAlbum = row.resourceInfoExtend.audioAlbum;
        that.editFileForm.audioBitRate = row.resourceInfoExtend.audioBitRate;
        that.editFileForm.audioSamplingRate =
          row.resourceInfoExtend.audioSamplingRate;
        that.editFileForm.audioTimeLong = row.resourceInfoExtend.audioTimeLong;
      } else if (row.type == 2) {
        that.editFileForm.videoSeriesTitle =
          row.resourceInfoExtend.videoSeriesTitle;
        that.editFileForm.videoDiversityTotal =
          row.resourceInfoExtend.videoDiversityTotal;
        that.editFileForm.videoColor = row.resourceInfoExtend.videoColor;
        that.editFileForm.videoPeriod = row.resourceInfoExtend.videoPeriod;
        that.editFileForm.videoVoice = row.resourceInfoExtend.videoVoice;
        that.editFileForm.videoCaption = row.resourceInfoExtend.videoCaption;
      }
      if (row.isOuter != null) {
        that.editFileForm.isOuter = row.isOuter;
      }
      that.editFileForm = {
        id: row.id,
        title: row.title,
        oldName: row.oldName,
        description: row.resourceInfoExtend.description,
        // isOriginal: row.isOriginal.toString(),
        subjectId: row.subjectId,
        type: row.type.toString(),
        logoPath: row.logoPath,
        httpPath: row.httpPath,
        contract: row.resourceInfoExtend.contract,
        permitTime: row.resourceInfoExtend.permitTime,
        word: row.resourceInfoExtend.word,
        origin: row.resourceInfoExtend.origin,
        originId: row.resourceInfoExtend.originId,
        permitType: row.resourceInfoExtend.permitType,
        permitScope: row.resourceInfoExtend.permitScope,
        resourceType: row.resourceInfoExtend.resourceType,
        dealtype: row.resourceInfoExtend.dealtype,
        zjr: row.resourceInfoExtend.zjr,
        zjrdw: row.zjrdw,
        zjrjj: row.resourceInfoExtend.zjrjj,
        wzg: row.resourceInfoExtend.wzg,
        menu: row.resourceInfoExtend.menu,
      };
      if (row.isOriginal != null) {
        that.editFileForm.isOriginal = row.isOriginal.toString();
      }
      this.editDialog = true;
    },
    // 选择表格某一行
    handleTableSelectionChange(val) {
      this.multipleSelectionTable = val;
    },
    // 左侧树搜索
    treeSearch(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.searchParam();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.searchParam();
    },
    // 分页
    handleSizeChange1(val) {
      this.pageSize1 = val;
      this.versionView();
    },
    handleCurrentChange1(val) {
      this.currentPage1 = val;
      this.versionView();
    },
    // 预览页面跳转
    preview(row) {
      var downloadA = document.createElement("a");
      downloadA.href = "/mediaPreview?id=" + row.id;
      downloadA.target = "_blank";
      downloadA.click();
      // this.$router.push({
      //   path: "/preview",
      //   query: { data: row.content, title: this.fileName },
      // });
    },
    // 发布预览跳转
     publishPreview(row) {
      var downloadA = document.createElement("a");
      switch (row.type) {
        case 1:
           downloadA.href = "/detail?id=" + row.id;
          break;
        case 2:
           downloadA.href = "/videoDetail?id=" + row.id;
          break;
        case 3:
           downloadA.href = "/audioDetail?id=" + row.id;
          break;
      
        default:
          break;
      }
      downloadA.target = "_blank";
      downloadA.click();
    },
    // 获取来源list
    getSourceList() {
      let that = this;
      $.ajax({
        type: "GET",
        dataType: "json",
        data: {
          page: 1,
          size: 1000,
        },
        url: "/zyk/c/source/sourceInfo/list",
        success: function (response) {
          if (response.code == 200) {
            that.optionData = response.obj.list;
            if (response.obj && response.obj.list.length == 0) {
              that.dataText = "暂无数据";
            }
            that.sourceList = response.obj.list;
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },
    handleCheckChange() {
      let that = this;
      let res = this.$refs.tree.getCurrentNode();
      this.selectedValue = res.name;
      // this.BUSubject = res.name;
      // that.BUSubjectId = res.id;
      that.editFileForm.subjectId = res.id;
    },
    // 类型选择改变时，文件类型也改变
    addTypeChange(value) {
      let that = this;
      if (value == 1) {
        that.acceptType = ".jpg,.png,.gif";
      } else if (value == 2) {
        that.acceptType = ".mp4";
      } else if (value == 3) {
        that.acceptType = ".mp3";
      }
    },

    downloadImportTemplate() {
      this.downloadTemplateDialog = true;
    },
    templateDownload() {
      let that = this;
      var downloadA = document.createElement("a");
      $.ajax({
        type: "GET",
        dataType: "json",
        url: "/zyk/resource/downloadImportTemplate",
        data: { tag: this.downloadTemplate },
        // contentType: "text/xml",
        success: function (response) {
          if (response.code == 200) {
            downloadA.href = response.obj.url;
            downloadA.download;
            downloadA.click();
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },
    batchUpload() {
      let that = this;
      that.BUType = "";
      that.BUSubjectId = "";
      this.createUpdateDialog = true;
    },
    // 缩略图上传成功钩子
    handleAvatarSuccess(response) {
      let that = this;
      that.logoImgUrl = response.obj;
      that.editFileForm.logoPath = response.obj;
    },
    beforeAvatarUpload(file) {
      let that = this;
      const isJPG = file.type == "image/jpeg";
      const isPNG = file.type == "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        this.$message.error("上传头像图片只能是 JPG或PNG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      } else {
        that.upLodeData = {
          type: this.editFileForm.type,
        };
      }
    },
    createIndex() {
      let params = Object.assign({}, this.searchFileForm);
      let that = this;
      let ids = this.multipleSelectionTable.map((item) => {
        return item.id;
      });
      if (ids.length == 0) {
        params.innerCode = this.listInnerCode;
      } else {
        params.ids = ids.toString();
      }
      $.ajax({
        type: "POST",
        dataType: "json",
        data: params,
        url: "/zyk/resource/createIndex",
        success: function (response) {
          if (response.code == 200) {
            that.$message({
              message: "索引已创建",
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },
    // 资源导出
    SourceOut() {
      var that = this;
      that.exportTitlesList = [];
      that.exportForm = Object.assign({}, this.searchFileForm);
      let ids = this.multipleSelectionTable.map((item) => {
        return item.id;
      });
      that.exportForm.ids = ids.toString();
      that.exportForm.exportKey = "Resource";
      that.exportForm.innerCode = this.listInnerCode;
      this.outDialog = true;
      $.ajax({
        url: "/zyk/a/exportList",
        type: "GET",
        //contentType: 'application/json;charset=utf-8',
        data: that.exportForm,
        dataType: "json",
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          var tagData = data.obj;
          for (var i = 0; i < tagData.length; i++) {
            that.exportTitlesList.push({
              value: tagData[i],
            });
          }
        },
      });
    },
    // 列表导出确认
    toExport() {
      var that = this;
      that.exportForm.exportTitles = this.exportForm.exportTitles.toString();
      var downloadA = document.createElement("a");
      $.ajax({
        url: "/zyk/a/exportList",
        type: "GET",
        //contentType: 'application/json;charset=utf-8',
        data: this.exportForm,
        dataType: "json",
        error: function (xhr) {
          console.log(xhr);
        },
        success: function (data) {
          downloadA.href = data.obj;
          downloadA.download;
          downloadA.click();
          that.outDialog = false;
        },
      });
    },
    // 导出xml数据包
    listOut() {
      var that = this;
      that.exportDataListForm = Object.assign({}, this.searchFileForm);
      let ids = this.multipleSelectionTable.map((item) => {
        return item.id;
      });
      that.exportDataListForm.ids = ids.toString();
      that.exportDataListForm.exportKey = "Resource";
      that.exportDataListForm.innerCode = this.listInnerCode;
      this.listOutDialog = true;
    },
    // 导出xml数据包确认
    exportDataList() {
      var that = this;
      if (this.exportDataListForm.isExportResource == "10") {
        this.exportDataListForm.isExportWatermark = "10";
        this.exportDataListForm.isExportSourceResource = "10";
      }
      $.ajax({
        url: "/zyk/a/exportDataList",
        type: "POST",
        //contentType: 'application/json;charset=utf-8',
        data: this.exportDataListForm,
        dataType: "json",
        error: function (xhr) {
          that.$message({
            message: xhr.msg,
            duration: 2000,
            showClose: true,
            type: "error",
            offset: 100,
          });
          that.listOutDialog = false;
        },
        success: function (data) {
          that.$message({
            message: data.msg,
            duration: 2000,
            showClose: true,
            type: "success",
            offset: 100,
          });
          that.listOutDialog = false;
        },
      });
    },
    // 根据Excel导出xml数据包提交
    exportDataListByExcel() {
      this.exportDataListByExcelDialog = true;
      var that = this;
      that.exportDataListForm.exportKey = "Resource";
    },
    // 上传文件之前的钩子，对文件大小进行校验
    excelBeforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 / 1024 < 4;

      if (!isLt2M) {
        this.$message.error("资源超过上传上限4G，如仍需上传，请联系管理员。");
        return isLt2M;
      } else {
        console.log("excleUpLodeData:" + this.excleUpLodeData);
      }
    },
    // 上传成功的钩子
    excelUploadSuccess(response) {
      let that = this;
      that.searchParam();
      that.$message({
        message: response.msg,
        duration: 0,
        showClose: true,
        type: "success",
        offset: 100,
      });
      that.exportDataListByExcelDialog = false;
    },
    excelUploaderror(err) {
      console.log(err);
    },
    excelsubmitUpload() {
      if (this.exportDataListForm.isExportResource == "10") {
        this.exportDataListForm.isExportWatermark = "10";
        this.exportDataListForm.isExportSourceResource = "10";
      }
      this.$refs.upload.submit();
    },
  },
};
</script>

<style>
#sortContent {
  clear: both;
  margin-top: -8px;
  margin-left: 170px;
}

.rightBox {
  float: right;
  width: calc(100% - 250px);
}
.information {
  width: 100%;
}

.el-dialog .el-form {
  padding: 10px 50px;
}

.reorderPreDialog {
  text-align: center;
}

.reorderPreDialog .el-input {
  display: inline;
}
.reorderPreDialog input {
  width: 100px;
}
.reorderPreDialog .red {
  color: red;
}

.mainBox {
  overflow: auto;
  border: 1px solid #dcdfe6;
  border-radius: 10px;
}
.mainBox::after,
.mainBox .leftBoxDialog {
  content: "";
  display: inline-block;
  clear: both;
}
.mainBox .leftBoxDialog {
  width: 30%;
  float: left;
  border-right: 1px solid #dcdfe6;
}
.mainBox .leftBoxDialog input {
  width: 100%;
  height: 30px;
  font-size: 14px;
}
.mainBox .leftBoxDialog .el-input,
.mainBox .leftBoxDialog .el-select {
  float: left;
}
.mainBox .leftBoxDialog .leftUp {
  border-bottom: 1px solid #50b58d;
  padding: 10px 0 10px 10px;
}

.mainBox .leftBoxDialog .el-input__icon {
  line-height: 30px;
}
.mainBox .rightBoxDialog {
  width: 69%;
  float: left;
}

.mainBox .rightBoxDialog .dialogBtnBox {
  border-bottom: 1px solid #50b58d;
  padding: 8px 0 8px 10px;
}

.mainBox .rightBoxDialog .el-form {
  padding: 10px 20px;
}

.mainBox .rightBoxDialog .el-form .el-textarea textarea {
  height: 300px;
}

#searchBox {
  padding-bottom: 22px;
}

#searchBox .el-select {
  width: 202px;
}

#searchBox .el-form-item {
  margin-bottom: 0;
}

#searchBox .el-form button.el-button {
  margin-left: 20px !important;
}

#searchBox .el-date-editor .el-range__icon,
#searchBox .el-date-editor .el-input__icon {
  line-height: 25px;
}

#searchBox.el-date-editor .el-range-separator {
  line-height: 23px;
}

.mediaManageBox {
  position: relative;
  font-family: "DBKai";
}

.mediaManageBox .tableLoading {
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  line-height: 200px;
  text-align: center;
  z-index: 10;
}
</style>